import { render, staticRenderFns } from "./Loads.vue?vue&type=template&id=792f5b42&scoped=true&"
import script from "./Loads.vue?vue&type=script&lang=js&"
export * from "./Loads.vue?vue&type=script&lang=js&"
import style0 from "./Loads.vue?vue&type=style&index=0&id=792f5b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792f5b42",
  null
  
)

export default component.exports